/** Web no-op — push is native-only; keeps notifee/messaging out of the web bundle. */
export function registerBackgroundHandlers(): void {}
